"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitStatement = exports.submitCacFile = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../styles/theme"));
const documentCard_1 = __importDefault(require("./documentCard"));
const businessOrganizationSlice_1 = require("../../features/profile/businessOrganization/businessOrganizationSlice");
const store_1 = require("../../store");
const financialBankAccountSlice_1 = require("../../features/profile/financialBankAccount.tsx/financialBankAccountSlice");
const text_1 = __importStar(require("../text/text"));
const constants_1 = require("../../constants/constants");
const spinner_1 = __importDefault(require("../spinner/spinner"));
const clipInputComponent_1 = __importDefault(require("./clipInputComponent"));
const input_1 = __importStar(require("../input/input"));
const primaryButton_1 = __importDefault(require("../primaryButton/primaryButton"));
const modal_1 = __importDefault(require("../modal/modal"));
const analytics_1 = require("../../utils/analytics/analytics");
const submitCacFile = async (document, dispatch, setErrors, addDocument, logEventWithExtraProperties) => {
    const payload = new FormData();
    const file = await fetch(document.file).then((r) => r.blob());
    // @ts-ignore
    payload.append('cac_documents', file, document.name);
    const resultDocument = await dispatch((0, businessOrganizationSlice_1.addCacCertificate)(payload));
    logEventWithExtraProperties('api_call', {
        name: 'add_cac_document',
        status: 'submitted',
        location: 'screen_MultiDocumentManager',
    });
    if ((0, toolkit_1.isFulfilled)(resultDocument)) {
        logEventWithExtraProperties('api_call', {
            name: 'add_cac_document',
            status: 'success',
            location: 'screen_MultiDocumentManager',
        });
        addDocument(resultDocument.payload);
    }
    else {
        logEventWithExtraProperties('api_call', {
            name: 'add_cac_document',
            status: 'fail',
            location: 'screen_MultiDocumentManager',
        });
        setErrors(resultDocument.payload);
    }
};
exports.submitCacFile = submitCacFile;
const submitStatement = async (document, dispatch, setErrors, addDocument, logEventWithExtraProperties, bankAccountId) => {
    const payload = new FormData();
    if (typeof document.file === 'string') {
        const file = await fetch(document.file).then((r) => r.blob());
        // @ts-ignore
        payload.append('bank_statement', file, document.name);
    }
    else {
        // @ts-ignore
        payload.append('bank_statement', document.file, document.name);
    }
    payload.append('document_password', document.password);
    if (bankAccountId) {
        const resultDocument = await dispatch((0, financialBankAccountSlice_1.addStatement)({ formData: payload, bankAccountId }));
        logEventWithExtraProperties('api_call', {
            name: 'add_manual_banks_document',
            status: 'submitted',
            location: 'screen_MultiDocumentManager',
        });
        if ((0, toolkit_1.isFulfilled)(resultDocument)) {
            logEventWithExtraProperties('api_call', {
                name: 'add_manual_banks_document',
                status: 'success',
                location: 'screen_MultiDocumentManager',
            });
            addDocument(resultDocument.payload);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'add_manual_banks_document',
                status: 'fail',
                location: 'screen_MultiDocumentManager',
            });
            setErrors(resultDocument.payload);
        }
    }
};
exports.submitStatement = submitStatement;
const MultiDocumentManager = ({ documents, setDocuments, screenName, requirements, mimeType, askPassword, uploadTo, preUploadForBankAccountId, deleteDocument, bankAccountId, error, label, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [statementPassword, setStatementPassword] = (0, react_1.useState)('');
    const [uploading, setUploading] = (0, react_1.useState)(false);
    const [dialogVisible, setDialogVisible] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)();
    const [specialError, setSpecialError] = (0, react_1.useState)(false);
    const [uploadedDocument, setUploadedDocument] = (0, react_1.useState)();
    const [uploadedDocumentName, setUploadedDocumentName] = (0, react_1.useState)('');
    const getFormats = () => {
        return `${mimeType
            .map((type) => (type ? type.split('/')[1].toUpperCase() : '')) // nosemgrep  - functions may result in Code Injection does not apply
            .join(', ')}`;
    };
    const addDocument = (document) => {
        setDocuments([...documents, document]);
    };
    const uploadToLogic = async (statementWithPassword) => {
        setUploading(true);
        if (bankAccountId) {
            uploadTo(statementWithPassword, dispatch, setErrors, addDocument, logEventWithExtraProperties, bankAccountId);
        }
        else if (preUploadForBankAccountId) {
            const bankAccountIdResult = await preUploadForBankAccountId();
            if (bankAccountIdResult) {
                uploadTo(statementWithPassword, dispatch, setErrors, addDocument, logEventWithExtraProperties, bankAccountIdResult);
            }
        }
        else {
            uploadTo(statementWithPassword, dispatch, setErrors, addDocument, logEventWithExtraProperties);
        }
        setUploading(false);
    };
    const deleteDocumentAux = async (documentId) => {
        setUploading(true);
        const result = await dispatch(deleteDocument({ documentId }));
        logEventWithExtraProperties('api_call', {
            name: 'delete_manual_banks_document',
            status: 'submitted',
            location: 'screen_MultiDocumentManager',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'delete_manual_banks_document',
                status: 'success',
                location: 'screen_MultiDocumentManager',
            });
            setDocuments(documents.filter((document) => document.id !== documentId));
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'delete_manual_banks_document',
                status: 'fail',
                location: 'screen_MultiDocumentManager',
            });
            setErrors(result.payload);
        }
        setUploading(false);
    };
    // Upload new document
    const selectDocument = async (ie) => {
        const file = ie.target.files[0];
        const fileURL = URL.createObjectURL(file);
        const urlExtension = file.name.split('.').pop();
        if (fileURL) {
            if (urlExtension && getFormats().indexOf(urlExtension.toUpperCase()) > -1) {
                setUploadedDocument(fileURL);
                setUploadedDocumentName(file.name);
                if (askPassword) {
                    setStatementPassword('');
                    setDialogVisible(true);
                }
                else {
                    uploadToLogic({ file: fileURL, name: file.name, password: '' });
                }
                setErrors(undefined);
                setSpecialError(false);
            }
            else {
                setSpecialError(true);
            }
        }
    };
    const fileInputRef = react_1.default.createRef();
    const pressInput = () => {
        fileInputRef.current.click();
    };
    const fileComponent = react_1.default.createElement("input", { ref: fileInputRef, type: "file", onChange: selectDocument, hidden: true });
    const submitPassword = () => {
        const oldDocuments = [...documents];
        const oldDocumentsWithoutTheLastDocument = documents.filter((document, index) => index < documents.length - 1 ? document : null);
        const lastDocument = oldDocuments[documents.length - 1];
        const lastDocumentWithPassord = { ...lastDocument, password: statementPassword };
        setDocuments(oldDocumentsWithoutTheLastDocument.concat([lastDocumentWithPassord]));
        uploadToLogic({
            file: uploadedDocument,
            name: uploadedDocumentName,
            password: statementPassword ? statementPassword.toString() : '',
        });
        setDialogVisible(false);
    };
    return !uploading ? (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(modal_1.default, { dismissModal: () => setDialogVisible(false), showModal: dialogVisible },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE }, t('multiDocumentManager.statement_password')),
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('multiDocumentManager.leave_blank')),
            react_1.default.createElement(react_native_1.View, { style: theme_1.default.styles.flexGrowOne },
                react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, label: "Password", placeholder: "Password", setValue: setStatementPassword, error: null, value: statementPassword }),
                react_1.default.createElement(primaryButton_1.default, { title: "Submit password", onPress: submitPassword, eventName: "add_statement_password" }))),
        label && (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, label)),
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_PRIMARY }, `Accepted file formats are: ${getFormats()}`),
        react_1.default.createElement(react_native_1.View, null,
            documents.map((document) => (react_1.default.createElement(documentCard_1.default, { key: document.id, document: { id: document.id, url: document.url, name: `Document #${document.id}` }, screenName: screenName, deleteDocument: () => deleteDocumentAux(document.id) }))),
            fileComponent,
            react_1.default.createElement(clipInputComponent_1.default, { onPress: pressInput, eventName: "select_document_from_list", toUploadTitle: "Select Document", showError: false, image: {} })),
        requirements.map((requirement) => (react_1.default.createElement(text_1.default, { key: requirement, titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, requirement))),
        (errors || error || specialError) && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, null,
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_ERROR, color: theme_1.default.colors.COLOR_CRITICAL },
                    error || constants_1.DEFAULT_ERROR_MESSAGE,
                    specialError && ` Invalid file format.`)))))) : (react_1.default.createElement(spinner_1.default, null));
};
MultiDocumentManager.defaultProps = {
    askPassword: false,
    preUploadForBankAccountId: undefined,
    bankAccountId: undefined,
    error: undefined,
    label: undefined,
};
exports.default = MultiDocumentManager;
